import styled from 'styled-components';
import bg_04 from '../../assets/images/bg_04.png';
import bg_05 from '../../assets/images/bg_05.png';

export const Wrapper = styled.div`
  height:100vh;overflow:auto;padding-top:5.86rem;
  padding-bottom:0;padding-bottom:env(safe-area-inset-bottom);background:#F7F7F7;
`;

export const Container = styled.div`
  .topFixed{
    width:100%;height:5.86rem;position:fixed;top:0;z-index:11;background: #F3F4F5;box-sizing:border-box;max-width: 475px;margin: 0 auto;
    border: 0 solid red;
  }
 .bg{
    width:100%;height:3.36rem;background:url(${bg_04}) no-repeat;background-size:100%;padding:.4rem .3rem 0;
    .left{
      width:1.2rem;height:1.2rem;border-radius:50%;float:left;margin-right:.2rem;
    }
    .center{
      float:left;
      >p{
        height: .5rem;font-size: .36rem;font-weight: 400;color: #FFFFFF;line-height: .5rem;margin-top:.1rem;
      }
      >div{
        overflow:hidden;position:absolute;
        b{
          position:relative;float:left;height: .4rem;font-size: .28rem;margin-right:.2rem;
          font-weight: 400;color: #FFFFFF;line-height: .4rem;
        }
        >div{
          position:relative;float:left;
          img{
            width:.4rem;height:.4rem;border-radius:50%;
          }
          >div{
            padding: .1rem 0 0 .2rem;width:2.46rem;height:1.4rem;margin-left:-.1rem;margin-top:.1rem;
            background:url(${bg_05}) no-repeat;background-size:100%;display:flex;align-items:center;justify-content:center;
            p{
              font-size: .22rem;font-weight: 400;color: #3B3D41;line-height:.34rem;
              span{
                color:#C47070;
              }
            }
          }
        }
      }
    }
    .right{
      flex:1;float:right;
      p{
        text-align:right;margin-top:.2rem;
        height: .34rem;font-size: .24rem;font-weight: 400;color: #FFFFFF;line-height: .34rem;
      }
      span{
        text-align:right;display:block;
        height: .4rem;font-size: .28rem;font-weight: 400;color: #FFFFFF;line-height: .4rem;
      }
    }
  }
  .navs{
    width: 92%;height: 2.4rem;background: #FFFFFF;box-shadow: 0px .02rem 1.4rem .06rem rgba(72, 119, 213, 0.11);
    border-radius: .1rem;margin: -1.5rem auto 0;
    .top{
      height:1.6rem;border-bottom: 1px solid #EEEEEE;display:flex;align-items:center;justify-content:center;padding:0 .4rem;
      .item{
        flex:1;height:.95rem;display:flex;flex-direction:column;align-items:center;justify-content:center;
        span{
          height: .53rem;font-size: .46rem;font-weight: 700;color: #3B3D41;line-height: .53rem;text-align:center;display:block;
        }
        span.red{
          color:#ED933C;
        }
        b{
          height: .33rem;font-size: .24rem;font-weight: 400;color: #9DA1A6;line-height: .33rem;
          text-align:center;display:block;margin-top:.08rem;
        }
      }
      .item:nth-child(1){
        border-right: 0 solid #DDDDDD;align-items:flex-start;flex:1;
      }
      .item:nth-child(2){
        align-items:flex-start;flex:none;
        /* min-width:1.7rem; */
      }
    }
    .bottom{
      display:flex;align-items:center;height:.8rem;padding:0 .3rem;
      div{
        display:flex;align-items:center;flex:1;
        p{
          font-size: .28rem;font-weight: 400;color: #9DA1A6;
        }
        span{
          font-size: .36rem;font-weight: 500;color: #3B3D41;margin:-.06rem 0 0 .1rem;
        }
      }
      >p{
        display:flex;align-items:center;justify-content:flex-end;
        img{
          width: .13rem;height:.22rem;display:block;margin-left:.1rem;
        }
        span{
          font-size: .28rem;font-weight: 400;color: #599AFF;
        }
      }
    }
  }
  .title{
    height: .4rem;font-size: .28rem;font-weight: 400;color: #3B3D41;line-height: .4rem;margin-top:.3rem;padding:0 .3rem;
    display:flex;align-items:center;
    p{
      font-size: .28rem;font-weight: 400;color: #3B3D41;
    }
    span{
      flex:1;text-align:right;font-size: .24rem;font-weight: 400;color: #9DA1A6;
    }
  }
  .tables{
    padding:0 .3rem;
    .table{
      height:.8rem;background:#ededed;display:flex;align-items:center;margin-top:.1rem;
      border-top-left-radius:.1rem;border-top-right-radius:.1rem;padding:0 .2rem;
      >p{
        flex:1;font-size: .28rem;font-weight: 400;color: #9DA1A6;border: 0 solid red;
      }
      p:nth-child(1){
        flex:none;width:1.4rem;
      }
      p:nth-child(2){
        span{
          
        }
      }
      p:nth-child(3){
        flex:none;width:1.1rem;
        span{
          
        }
      }
      p:nth-child(4){
        text-align:right;
      }
    }
  }
  .lists{
    padding:0 .3rem .3rem;
    .list{
      background: #FFFFFF;padding:0;border-bottom-left-radius:.1rem;border-bottom-right-radius:.1rem;
      padding:0 .2rem .3rem .2rem;border-top:1px solid #FFFFFF;border:0 solid red;border-top:1px solid #FFFFFF;
      .item{
        .item1{
          height:.4rem;display:flex;align-items:center;justify-content:center;margin-top:.3rem;border: 0 solid red;
          font-size: .28rem;font-weight: 400;color: #3B3D41;
          >p{
            flex:1;border: 0 solid red;
          }
          .p1{
            flex:none;width:1.4rem;
          }
          .p2{
            color: #9DA1A6;
          }
          .p2.blue{
            color: #45AF83;
          }
          .p3{
            flex:none;width:1.1rem;
          }
          .p4{
            text-align:right;
            span{
              margin-right:.45rem;
            }
          }
          .blue{
            color: #45AF83;
          }
        }
        .bgn{
          background: #F7F7F7;border: 0 solid red;margin-top:.24rem;padding:0 0 .3rem 0;border-top:1px solid #F7F7F7;
          position: relative;
          >img{
            width:.38rem;height:.15rem;display:block;position: absolute;top:-.15rem;right:.32rem;
          }
          .item2{
            display:flex;align-items:center;justify-content:center;margin-top:.3rem;
            >p{
              flex:1;border: 0 solid red;
            }
            .p1{
              flex:none;width:1.4rem;
              span{
                margin-left:.2rem;
              }
            }
            .p2{
              color: #9DA1A6;
            }
            .p3{
              flex:none;width:1.1rem;
            }
            .p4{
              text-align:right;
              span{
                color: #9DA1A6;margin-right:.2rem;
              }
            }
            .blue{
              color: #45AF83;
            }
          }
        }
      }
    }
    .tips{
      font-size:.26rem;text-align:center;margin-top: .3rem;color:#999999;
    }
  }
`; 